import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

interface CustomText {
  update?: string;
  resume?: string;
  resubscribe?: string;
  cancel?: string;
}

function useOnSubscriptionRedirect({
  custom,
  duration,
}: { custom?: CustomText; duration?: number } = {}) {
  const [params, setParams] = useSearchParams();

  const isSuccess = params.get('success') === 'true';
  const method = params.get('method');

  React.useEffect(() => {
    if (isSuccess && !toast.isActive('subscription-success')) {
      if (
        !method ||
        !['cancel', 'update', 'resume', 'resubscribe'].includes(method)
      )
        return;
      const message =
        method === 'update'
          ? custom?.update ?? 'Payment method updated!'
          : method === 'resume'
          ? custom?.resume ?? 'Subscription resumed!'
          : method === 'resubscribe'
          ? custom?.resubscribe ?? "You're subscribed!"
          : custom?.cancel ?? 'Subscription canceled';
      toast.success(message, {
        toastId: 'subscription-success',
        autoClose: duration,
      });
      setParams(() => new URLSearchParams().toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useOnSubscriptionRedirect;
